import React from "react";
import { Divider, OutlinedInput } from "@mui/material";
import {
	CustomButton,
	CustomTooltip,
	IconComponent,
	Selector,
	icon,
} from "../../../../../../../../../../common/components";
import { dangerousSetInnerHTML } from "../../../../../../../../../../common/utils";
import { translate, translateEnumVersionStatus } from "../../../../../../../../../../common/providers";
import { setDisableKeyEvents } from "../../../../../../../../../../common/slice";
import styles from "../VersioningTabView.module.css";
import { VERSION_STATUSES } from "../../../../../../../../constants/constants";

function VersionText({ text }) {
	return dangerousSetInnerHTML({ text });
}
export default function AccordionUploaded({
	content,
	dispatch,
	displayError,
	documentInfo,
	handleChange,
	handleApply,
	handleOpenComparison,
	handleSelect,
	hasLeaderPermissions,
	idValue,
	infoUpdated,
	informationId,
	original,
	status,
	versionStatuses,
}) {
	return (
		<div>
			<div className={styles.versionComparisonHeader}>
				<div className={styles.versionColumn}>
					<div className={styles.versionLabel}>
						{translate("smart-review.cmp-details.option-panel.versioning.comparison.new-version")}
					</div>
					<CustomTooltip title={documentInfo?.documentName || ""}>
						<div className={styles.versionDocName}>{documentInfo?.documentName}</div>
					</CustomTooltip>
				</div>
				<div className={styles.verticalDivider} />
				<div className={styles.versionColumn}>
					<div className={styles.versionLabel}>
						{translate("smart-review.cmp-details.option-panel.versioning.comparison.old-version")}
					</div>
					<CustomTooltip title={documentInfo?.previousVersionName || ""}>
						<div className={styles.versionDocName}>{documentInfo?.previousVersionName}</div>
					</CustomTooltip>
				</div>
			</div>
			{status !== VERSION_STATUSES.NEW && (
				<div className={styles.compareButtonContainer}>
					<CustomButton
						color="secondary"
						data-testid="compare.btn"
						startIcon={icon.aitClipBoardCheck}
						variant="outlined"
						onClick={handleOpenComparison}
					>
						{translate("smart-review.cmp-details.option-panel.versioning.comparison.button")}
					</CustomButton>
				</div>
			)}
			<Divider />

			<div className={styles.content}>
				{!displayError && <VersionText text={original?.diff || content} />}
				{displayError && translate("smart-review.cmp-details.option-panel.versioning.information-id.error")}
			</div>
			<div className={styles.infoIdRow}>
				<OutlinedInput
					classes={{
						root: styles.infoIdInput,
					}}
					disabled={!hasLeaderPermissions}
					placeholder={translate("smart-review.cmp-details.option-panel.versioning.information-id")}
					type="number"
					value={idValue || 0}
					onBlur={() => dispatch(setDisableKeyEvents(false))}
					onChange={handleChange}
					onFocus={() => dispatch(setDisableKeyEvents(true))}
				/>
				<IconComponent
					className={styles.infoIdArrow}
					color="var(--text-secondary)"
					icon={icon.faArrowRight}
					size="sm"
				/>
				<span className={styles.infoIdText}>
					{informationId &&
						translate(
							documentInfo.sidePanelIsRequirement
								? "smart-review.cmp-details.option-panel.versioning.info-requirement"
								: "smart-review.cmp-details.option-panel.versioning.info-information",
							{
								infoId: informationId,
							}
						)}
				</span>
			</div>

			<div className={styles.content}>
				<div className={styles.statusSection}>
					{hasLeaderPermissions && (
						<>
							<Selector
								autoTranslate="no"
								className={styles.statusSelector}
								itemRenderer={(label) => translateEnumVersionStatus(label)}
								items={versionStatuses || []}
								textFieldClassName={styles.textFieldClassName}
								value={status}
								valueRenderer={(label) => translateEnumVersionStatus(label)}
								onChange={handleSelect}
							/>
							<CustomTooltip>
								<span>
									<CustomButton disabled={!infoUpdated} variant="contained" onClick={handleApply}>
										{translate("common:btn.apply")}
									</CustomButton>
								</span>
							</CustomTooltip>
						</>
					)}
					{!hasLeaderPermissions && <span>{translateEnumVersionStatus(status)}</span>}
				</div>
			</div>
		</div>
	);
}
